<template>
  <form novalidate @submit.prevent="submit" v-if="userGroup" class="entity-form">
    <v-progress-bar md-mode="indeterminate" v-if="isLoading" />
    <user-group-form-fields ref="userGroupFormFields" :user-group="userGroup" :users="availableUsers" @change="updateUserGroupObject" />

    <br />
    <div class="u-flex u-space-between">
      <v-button type="submit" :disabled="isLoading">Shrani</v-button>
      <v-button @click="goBack">Nazaj</v-button>
    </div>
  </form>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BackMixin from '@/components/shared/BackMixin'
import UserGroupFormFields from './UserGroupFormFields'
import VButton from 'design-system/VButton.vue'
import VProgressBar from 'design-system/VProgressBar.vue'

export default {
  components: {
    UserGroupFormFields,
    VButton,
    VProgressBar,
  },
  mixins: [BackMixin],
  computed: {
    ...mapState('accountStore/userGroups/forms', ['userGroup', 'availableUsers']),
    ...mapState(['isLoading']),
  },
  methods: {
    ...mapActions('accountStore/userGroups/forms', ['updateUserGroupObject']),
    submit () {
      this.runAllValidations()
      if (!this.isValid()) {
        return
      }

      this.$emit('submit')
    },
    runAllValidations () {
      this.$refs.userGroupFormFields.runAllValidations()
    },
    isValid () {
      return this.$refs.userGroupFormFields.isValid()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/components/common';
</style>

